// extracted by mini-css-extract-plugin
export default {"tabs":"AOL8t"};